// eslint-disable-next-line
export default {
    name: "Main",
    status: {
        router: true,
        redux: true
    }
}
